import request from "@/service";

/* 查询审核列表 */
export function moveAuditList(data) {
  return request({
    url: "/user/user/audit/page",
    method: "get",
    params: data
  });
}
export function auditFindAuditInfo(data) {
  return request({
    url: "/user/user/audit/findAuditInfo",
    method: "get",
    params: data
  });
}

export function auditFindAuditStep(data) {
  return request({
    url: "/user/user/audit/findAuditStep",
    method: "get",
    params: data
  });
}




// 获取审核记录
export function auditHistoryList(id) {
  return request({
    url: `/user/user/audit/list/${id}`,
    method: "get"
  });
}

// 更新审核记录
export function auditHistoryUpdate(data) {
  return request({
    url: `/user/user/audit/update`,
    method: "put",
    data
  });
}

// 权限转让审核接口
export function auditTransferUpdate(data) {
  return request({
    url: `/user/permissionMoveRecord/audit`,
    method: "post",
    data
  });
}


